import { useState } from 'react';
import { Chip, Box, Tooltip, ClickAwayListener, Popper, Paper, Typography, Stack, Button, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useSubscription } from 'features/subscription/useSubscription';

export default function PlanNavbarBadge() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { isFree, isPaid, planName, creditBalance } = useSubscription();

  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title="View plan details">
        <Chip
          icon={<RocketLaunchIcon sx={{ fontSize: 16 }} />}
          label={
            downSM
              ? (isFree ? 'Free' : planName)
              : (isFree ? (creditBalance > 0 ? `Free · ${creditBalance} credits` : 'Free') : `${planName} · ${creditBalance} credits`)
          }
          size="small"
          color={isPaid ? 'success' : 'default'}
          variant={isPaid ? 'filled' : 'outlined'}
          onClick={handleClick}
          sx={{ cursor: 'pointer', fontWeight: 600 }}
        />
      </Tooltip>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 2.5, borderRadius: 2, boxShadow: 3, minWidth: 280, maxWidth: 320 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
              <Typography variant="subtitle2" fontWeight={600}>Current Plan</Typography>
              <Chip
                label={isFree ? 'Free' : planName}
                size="small"
                color={isPaid ? 'success' : 'default'}
              />
            </Stack>

            <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
              {planName}
            </Typography>

            {isFree ? (
              <Box sx={{ mt: 1 }}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="caption" color="text.secondary">SMS Credits</Typography>
                  <Typography variant="caption" fontWeight={600}>{creditBalance} available</Typography>
                </Stack>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                  {creditBalance > 0
                    ? 'Using your purchased credits — subscribe to a plan for full access'
                    : 'No SMS credits — subscribe to a plan or buy credits to send SMS'}
                </Typography>
              </Box>
            ) : (
              <Box sx={{ mt: 1 }}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="caption" color="text.secondary">SMS Credits</Typography>
                  <Typography variant="caption" fontWeight={600}>{creditBalance} available</Typography>
                </Stack>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                  Pay-as-you-go SMS credits
                </Typography>
              </Box>
            )}

            <Button
              fullWidth
              variant={isFree ? 'contained' : 'outlined'}
              size="small"
              sx={{ mt: 2, borderRadius: 2 }}
              onClick={() => {
                handleClose();
                navigate(isFree ? '/select-plan' : '/billing');
              }}
            >
              {isFree ? 'Upgrade to Pro' : 'Manage Billing'}
            </Button>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
